export const LoadingSpinner = () => {
  return (
    <div class="flex m-4 justify-center items-center">
      <span class="loading loading-spinner loading-md motion-reduce:hidden"></span>
      <span class="motion-safe:hidden">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;
